export const convertSelectData = ({
  data,
  valueField = "id",
  labelField = "label",
}) => {
  if (!data) {
    return [];
  }

  const convertedData = data.map((obj) => {
    return {
      ...obj,
      value: obj[valueField],
      label: obj[labelField],
    };
  });

  return convertedData;
};
